import { useField, useFormikContext } from 'formik'
import { Select } from 'components/Select/Select'
import { SelectProps } from 'components/Select/Types'
import { FormStatus } from 'components/Wizards/Wizard/Form/Types'
import { FormButton } from '../FormButton/FormButton'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'

interface Props extends Omit<SelectProps<string>, 'name' | 'children'> {
  name: string
  children: JSX.Element[]
}

export const SelectInput = (props: Props) => {
  const [field, , helpers] = useField(props.name)
  const { status } = useFormikContext()
  const { isMobile } = useResponsiveDesign()

  if (status === FormStatus.AutoFilling) {
    return <TextFieldLoadingState fixedWidth={300} />
  }

  return (
    <Select
      size="lg"
      variant='secondary'
      aria-label={props['aria-label']}
      selectedKey={field.value}
      onSelectionChange={(key) => {
        helpers.setValue(key as string)
      }}
      ButtonComponent={isMobile ? FormButton : undefined}
    >
      {props.children}
    </Select>
  )
}
